import React from "react";

import FormatColorFillIcon from "@material-ui/icons/FormatColorFill";
import FontDownloadOutlinedIcon from "@material-ui/icons/FontDownloadOutlined";
import FilterFramesOutlinedIcon from "@material-ui/icons/FilterFramesOutlined";
import BorderOuterOutlinedIcon from "@material-ui/icons/BorderOuterOutlined";
import BusinessCenterOutlinedIcon from "@material-ui/icons/BusinessCenterOutlined";
import TitleOutlinedIcon from "@material-ui/icons/TitleOutlined";
import TextFieldsOutlinedIcon from "@material-ui/icons/TextFieldsOutlined";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import BorderBottomOutlinedIcon from "@material-ui/icons/BorderBottomOutlined";
import BorderTopOutlinedIcon from "@material-ui/icons/BorderTopOutlined";
import ChatBubbleOutlineOutlinedIcon from "@material-ui/icons/ChatBubbleOutlineOutlined";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import FormatListBulletedOutlinedIcon from "@material-ui/icons/FormatListBulletedOutlined";
import ViewDayOutlinedIcon from "@material-ui/icons/ViewDayOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import EventAvailableOutlinedIcon from "@material-ui/icons/EventAvailableOutlined";
import EventBusyOutlinedIcon from "@material-ui/icons/EventBusyOutlined";
import InputOutlinedIcon from "@material-ui/icons/InputOutlined";
import SearchIcon from "@material-ui/icons/Search";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import PanoramaOutlinedIcon from "@material-ui/icons/PanoramaOutlined";
import { templateHelper } from "../helpers/templateHelper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import SubjectIcon from "@material-ui/icons/Subject";
import BarChartOutlinedIcon from "@material-ui/icons/BarChartOutlined";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import KeyboardArrowUpOutlinedIcon from "@material-ui/icons/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@material-ui/icons/KeyboardArrowDownOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import HeightOutlinedIcon from "@material-ui/icons/HeightOutlined";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import FormatAlignRightIcon from "@material-ui/icons/FormatAlignRight";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import SendIcon from "@material-ui/icons/Send";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import RemoveIcon from "@material-ui/icons/Remove";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";
import GridOnOutlinedIcon from "@material-ui/icons/GridOnOutlined";
//#region icons

const helpIcon = <HelpOutlineOutlinedIcon className="primary-text" />;
const colorIcon = <FormatColorFillIcon className="primary-text" />;
const fontIcon = <FontDownloadOutlinedIcon className="primary-text" />;
const frameIcon = <FilterFramesOutlinedIcon className="primary-text" />;
const borderIcon = <BorderOuterOutlinedIcon className="primary-text" />;
const logoIcon = <BusinessCenterOutlinedIcon className="primary-text" />;
const titleIcon = <TitleOutlinedIcon className="primary-text" />;
const subtitleIcon = <TextFieldsOutlinedIcon className="primary-text" />;
const sendIcon = <SendOutlinedIcon className="primary-text" />;
const headerIcon = <BorderTopOutlinedIcon className="primary-text" />;
const footerIcon = <BorderBottomOutlinedIcon className="primary-text" />;
const chatIcon = <ChatBubbleOutlineOutlinedIcon className="primary-text" />;
const messageBoxIcon = <ListAltOutlinedIcon className="primary-text" />;
const searchIcon = <SearchOutlinedIcon className="primary-text" />;
const listIcon = <FormatListBulletedOutlinedIcon className="primary-text" />;
const listItemIcon = <ViewDayOutlinedIcon className="primary-text" />;
const nameIcon = <PersonOutlineOutlinedIcon className="primary-text" />;
const avatarIcon = <AccountCircleOutlinedIcon className="primary-text" />;
const breakoutButtonIcon = <InputOutlinedIcon className="primary-text" />;
const searchbarIcon = <SearchIcon className="primary-text" />;
const textIcon = <SubjectIcon className="primary-text" />;
const chartIcon = <BarChartOutlinedIcon className="primary-text" />;
const buttonIcon = <TouchAppOutlinedIcon className="primary-text" />;
const linkIcon = <LinkOutlinedIcon className="primary-text" />;
const inputIcon = <EditOutlinedIcon className="primary-text" />;

const scrollIcon = <HeightOutlinedIcon className="primary-text" />;

const activeAgendaIcon = <EventAvailableOutlinedIcon className="primary-text" />;
const defaultAgendaIcon = <CalendarTodayOutlinedIcon className="primary-text" />;
const passedAgendaIcon = <EventBusyOutlinedIcon className="primary-text" />;
const tableHeadIcon = <TableChartOutlinedIcon className="primary-text" />;
const tableIcon = <GridOnOutlinedIcon className="primary-text" />;
//#region interactionSettingsList

const userCardSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.frame",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.frame",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.userCard.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.userCard.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
    ],
  },
  {
    group: "Avatar",
    icon: avatarIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.avatar",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.avatar",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.userCard.avatar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Name",
    icon: nameIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.name",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.userCard.name",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.userCard.name",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.userCard.name",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Company",
    icon: logoIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.userCard.company",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.userCard.company",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.userCard.company",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.userCard.company",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];
const clientListSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.frame",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.clientList.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 100,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.clientList.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 100,
          min: 0,
        },
      },
    ],
  },

  {
    group: "Header",
    icon: headerIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.header",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.header",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.clientList.header",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.clientList.header",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.clientList.header",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Avatar",
    icon: avatarIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.avatar",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.avatar",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.clientList.avatar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "SearchBar",
    icon: searchbarIcon,
    items: [
      {
        name: "iconColor",
        label: "IconColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.searchBar",
      },
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.searchBar",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.searchBar",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.searchBar",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.clientList.searchBar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.clientList.searchBar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.clientList.searchBar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "width",
        label: "Width",
        type: "SLIDER",
        path: "interaction.clientList.searchBar",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "List",
    icon: listIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.list",
      },
    ],
  },
  {
    group: "ListItem",
    icon: listItemIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.listItem",
      },
      {
        name: "width",
        label: "Width",
        type: "SLIDER",
        path: "interaction.clientList.listItem",
        extra: {
          defaultValue: 4,
          units: ["%"],
          max: 100,
          min: 0,
        },
      },
      {
        name: "margin",
        label: "Margin",
        type: "SLIDER",
        path: "interaction.clientList.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.listItem",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.clientList.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.clientList.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
    ],
  },
  {
    group: "Name",
    icon: nameIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.listItem.name",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.clientList.listItem.name",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.clientList.listItem.name",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.clientList.listItem.name",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Company",
    icon: logoIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.clientList.listItem.company",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.clientList.listItem.company",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.clientList.listItem.company",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.clientList.listItem.company",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];

const pollTemplateSettingsList = [
  {
    group: "Placeholder",
    icon: <EqualizerIcon className="primary-text" />,
    items: [
      {
        name: "iconColor",
        label: "IconColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.placeholder",
      },
      {
        name: "iconBackgroundColor",
        label: "IconBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.placeholder",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.placeholder",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.poll.placeholder",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.placeholder",
      },
    ],
  },
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.frame",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.frame",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.poll.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.poll.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
    ],
  },
  {
    group: "TextInput",
    icon: inputIcon,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.textInput",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.textInput",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.textInput",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.poll.textInput",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.poll.textInput",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.poll.textInput",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.poll.textInput",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.textInput",
      },
    ],
  },
  {
    group: "SendButton",
    icon: <SendIcon className="primary-text" />,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.sendButton",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.sendButton",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.sendButton",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.poll.sendButton",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.poll.sendButton",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.poll.sendButton",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.poll.sendButton",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.sendButton",
      },
    ],
  },

  {
    group: "BoxOption",
    icon: <CheckBoxIcon className="primary-text" />,
    items: [
      {
        name: "checkedColor",
        label: "CheckedColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.boxOption",
      },
      {
        name: "uncheckedColor",
        label: "UncheckedColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.boxOption",
      },
    ],
  },
  {
    group: "QuestionTitle",
    icon: titleIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.questionTitle",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.poll.questionTitle",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.questionTitle",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.poll.questionTitle",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "rem", "vh"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "textAlign",
        label: "TextAlignment",
        type: "BUTTON_GROUP_SMALL",
        showIf: null,
        path: "interaction.poll.questionTitle",
        extra: [
          { name: "left", label: "Left", icon: <FormatAlignLeftIcon /> },
          { name: "center", label: "Center", icon: <FormatAlignCenterIcon /> },
          { name: "right", label: "Right", icon: <FormatAlignRightIcon /> },
        ],
      },
    ],
  },
  {
    group: "ButtonOption",
    icon: buttonIcon,
    items: [
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.poll.buttonOption",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.poll.buttonOption",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "rem", "vh"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.buttonOption",
        separator: true,
      },
      {
        name: "margin",
        label: "Margin",
        type: "SLIDER",
        path: "interaction.poll.buttonOption",
        extra: {
          defaultValue: 4,
          units: ["px"],
          max: 50,
          min: 0,
        },
        separator: true,
      },
      {
        name: "defaultBackgroundColor",
        label: "DefaultBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
      {
        name: "defaultBorderColor",
        label: "DefaultBorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
      {
        name: "defaultTextColor",
        label: "DefaultTextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
        separator: true,
      },
      {
        name: "checkedBackgroundColor",
        label: "CheckedBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
      {
        name: "checkedBorderColor",
        label: "CheckedBorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
      {
        name: "checkedTextColor",
        label: "CheckedTextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.buttonOption",
      },
    ],
  },
  {
    group: "Pagination",
    icon: <ArrowForwardIosIcon className="primary-text" />,
    items: [
      {
        name: "stepColor",
        label: "ArrowColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.pagination",
      },
      {
        name: "textColor",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.poll.pagination",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.poll.pagination",
      },
    ],
  },
];

const breakoutSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.frame",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.frame",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.breakouts.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.breakouts.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
    ],
  },
  {
    group: "Title",
    icon: titleIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.title",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.breakouts.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.breakouts.title",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.breakouts.title",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "RowDivider",
    icon: <RemoveIcon className="primary-text" />,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.rowDivider",
      },
      {
        name: "height",
        label: "Height",
        type: "SLIDER",
        path: "interaction.breakouts.rowDivider",
        extra: {
          defaultValue: 1,
          units: ["%", "px", "vh", "rem"],
          max: 30,
          min: 1,
          min: 1,
        },
      },
    ],
  },
  {
    group: "Subtitle",
    icon: subtitleIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.subtitle",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.breakouts.subtitle",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.breakouts.subtitle",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.breakouts.subtitle",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Description",
    icon: <DescriptionOutlinedIcon className="primary-text" />,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.description",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.breakouts.description",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.breakouts.description",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.breakouts.description",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "ReadMore",
    icon: <UnfoldMoreIcon className="primary-text" />,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.readMore",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.breakouts.readMore",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.breakouts.readMore",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.breakouts.readMore",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
        },
      },
      /* {
        name: "marginTop",
        label: "MarginTop",
        type: "SLIDER",
        path: "interaction.breakouts.readMore",
        extra: {
          defaultValue: 4,
          units: ["%", "px",],
          max: 50,
          min: 0,
        },
      }, */
    ],
  },
  /*  {
    group: "List",
    icon: listIcon,
    items: [
   
      {
        name: "width",
        label: "Width",
        type: "SLIDER",
        path: "interaction.breakouts.list",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
    ],
  }, */
  {
    group: "ListItem",
    icon: listItemIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem",
      },
      /*     {
        name: "marginLeft",
        label: "MarginLeft",
        type: "SLIDER",
        path: "interaction.breakouts.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px", 'vh', 'rem'],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "marginRight",
        label: "MarginRight",
        type: "SLIDER",
        path: "interaction.breakouts.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      }, */
      /*  {
        name: "width",
        label: "Width",
        type: "SLIDER",
        path: "interaction.breakouts.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 100,
          min: 0,
        },
      }, */
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.breakouts.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.breakouts.listItem",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0,
        },
      },
    ],
  },
  {
    group: "ListItemButton",
    icon: breakoutButtonIcon,
    items: [
      {
        name: "color",
        label: "IconColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.button",
      },
    ],
  },
  {
    group: "ListItemText",
    icon: subtitleIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.text",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.breakouts.listItem.text",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.breakouts.listItem.text",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.breakouts.listItem.text",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "vh", "rem"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "ListItemAvatar",
    icon: avatarIcon,
    items: [
      {
        name: "color",
        label: "Color",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.avatar",
      },
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.avatar",
        separator: true,
      },
      {
        name: "activeColor",
        label: "ActiveColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.avatar",
      },
      {
        name: "activeBackground",
        label: "ActiveBackground",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.breakouts.listItem.avatar",
      },
    ],
  },
];
const agendaSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.content",
      },
      /*   {
        name: "background",
        label: "BackgroundImage",
        type: "MULTI_INPUT",
        showIf: null,
        path: "interaction.agenda.content",
      }, */
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.content",
      },
      {
        name: "padding",
        label: "Padding",
        type: "SLIDER",
        path: "interaction.agenda.content",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.agenda.content",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.agenda.content",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Title",
    icon: titleIcon,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.title",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          steps: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.title",
      },
      {
        name: "marginLeft",
        label: "MarginLeft",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          steps: 0.1,
          min: 0,
        },
      },
    ],
  },
  {
    group: "Subtitle",
    icon: subtitleIcon,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.subtitle",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.subtitle",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          steps: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.subtitle",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.subtitle",
      },
      {
        name: "marginLeft",
        label: "MarginLeft",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.subtitle",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          steps: 0.1,
          min: 0,
        },
      },
    ],
  },

  {
    group: "AgendaRow",
    icon: listItemIcon,
    items: [
      {
        name: "padding",
        label: "Padding",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.agendaItem",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.agendaItem",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.agendaItem",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
    ],
  },
  {
    group: "DefaultRow",
    icon: defaultAgendaIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.default.item",
      },

      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.default.item",
        separator: true,
      },
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.default.title",
      },
      {
        name: "fontSize",
        label: "TitleFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.default.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "TitleFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.default.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.default.title",
        separator: true,
      },
      {
        name: "color",
        label: "DescriptionTitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.default.text",
      },
      {
        name: "fontSize",
        label: "DescriptionFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.default.text",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "DescriptionFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.default.text",
      },
      {
        name: "fontFamily",
        label: "DescriptionFontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.default.text",
      },
    ],
  },
  {
    group: "ActiveRow",
    icon: activeAgendaIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.active.item",
      },

      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.active.item",
        separator: true,
      },
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.active.title",
      },
      {
        name: "fontSize",
        label: "TitleFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.active.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "TitleFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.active.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.active.title",
        separator: true,
      },
      {
        name: "color",
        label: "DescriptionTitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.active.text",
      },
      {
        name: "fontSize",
        label: "DescriptionFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.active.text",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "DescriptionFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.active.text",
      },
      {
        name: "fontFamily",
        label: "DescriptionFontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.active.text",
      },
    ],
  },
  {
    group: "PassedRow",
    icon: passedAgendaIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.passed.item",
      },

      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.passed.item",
        separator: true,
      },
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.passed.title",
      },
      {
        name: "fontSize",
        label: "TitleFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.passed.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "TitleFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.passed.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.passed.title",
        separator: true,
      },
      {
        name: "color",
        label: "DescriptionTitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.agenda.passed.text",
      },
      {
        name: "fontSize",
        label: "DescriptionFontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.agenda.passed.text",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "DescriptionFontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.agenda.passed.text",
      },
      {
        name: "fontFamily",
        label: "DescriptionFontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.agenda.passed.text",
      },
    ],
  },
];
const chatSettingsList = [
  {
    group: "Colors",
    icon: colorIcon,
    items: [
      {
        name: "primaryColor",
        label: "PrimaryColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat",
      },
      {
        name: "secondaryColor",
        label: "SecondaryColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat",
      },
      {
        name: "badgePillColor",
        label: "BadgePillColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat",
      },
      {
        name: "sendButtonColor",
        label: "SendButtonColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat",
      },
    ],
  },
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.container",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.chat.container",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        path: "interaction.chat.container",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Header",
    icon: headerIcon,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.header",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.header",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.header",
      },

      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.chat.header",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "rem", "vh"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.chat.header",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.chat.header",
      },
    ],
  },

  {
    group: "MessageFrame",
    icon: messageBoxIcon,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.content",
      },
      {
        name: "background",
        label: "BackgroundImage",
        type: "MULTI_INPUT",
        showIf: null,
        path: "interaction.chat.content",
      },
    ],
  },
  {
    group: "MessageBubble",
    icon: chatIcon,
    items: [
      {
        name: "color",
        label: "SenderNameColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.chat.messages",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "rem", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "titleSize",
        label: "MessageTitleSize",
        type: "SLIDER",
        path: "interaction.chat.messages",
        extra: {
          defaultValue: 4,
          units: ["%", "px", "rem", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.chat.messages",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.chat.messages",
      },
      {
        name: "color",
        label: "SenderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages.sender",
      },
      {
        name: "adminTextColor",
        label: "AdminBubbleTextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages",
      },
      {
        name: "adminBackgroundColor",
        label: "AdminBubbleBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages",
      },
      {
        name: "color",
        label: "ReceiverColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages.receiver",
      },

      {
        name: "backgroundColor",
        label: "SenderBubbleBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages.sender",
      },
      {
        name: "backgroundColor",
        label: "ReceiverBubbleBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.messages.receiver",
      },
    ],
  },
  {
    group: "Footer",
    icon: footerIcon,
    items: [
      {
        name: "background",
        label: "Background",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.footer",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.footer",
      },
      {
        name: "inputColor",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.chat.footer",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.chat.footer",
      },
    ],
  },
];
const clientFrameSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.client.frame",
      },
      {
        name: "minWidth",
        label: "minWidth",
        type: "SLIDER",
        path: "interaction.client.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "maxWidth",
        label: "maxWidth",
        type: "SLIDER",
        path: "interaction.client.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.client.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Title",
    icon: titleIcon,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.client.frame",
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.client.frame",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.client.frame",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.client.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },

  {
    group: "SendButton",
    icon: sendIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.client.sendButton",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.client.sendButton",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        path: "interaction.client.sendButton",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.client.sendButton",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.client.sendButton",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        path: "interaction.client.sendButton",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];
const exhibitorSettingsList = [
  {
    group: "Frame",
    icon: frameIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.exhibitor.frame",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "padding",
        label: "Padding",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.frame",
        extra: {
          defaultValue: 4,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Logo",
    icon: logoIcon,
    items: [
      {
        name: "background",
        label: "LogoCardBackground",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.exhibitor.logo",
      },
      {
        name: "width",
        label: "Width",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.logo",
        extra: {
          defaultValue: 350,
          units: ["%", "px"],
          max: 500,
          min: 1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.logo",
        extra: {
          defaultValue: 15,
          units: ["%", "px"],
          max: 50,
          min: 0.1,
        },
      },
    ],
  },
  {
    group: "Title",
    icon: titleIcon,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.exhibitor.title",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.exhibitor.title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.exhibitor.title",
      },
    ],
  },
  {
    group: "Subtitle",
    icon: subtitleIcon,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.exhibitor.subtitle",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.exhibitor.subtitle",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.exhibitor.subtitle",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.exhibitor.subtitle",
      },
    ],
  },
];
const connectionSettingsList = [
  {
    group: "Colors",
    icon: colorIcon,
    items: [
      {
        name: "background",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.connections",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.connections",
      },
    ],
  },
  {
    group: "Border",
    icon: borderIcon,
    items: [
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "interaction.connections",
        extra: {
          defaultValue: 1,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "interaction.connections",
        extra: {
          defaultValue: 1,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },

      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "interaction.connections",
      },
    ],
  },
  {
    group: "Fonts",
    icon: fontIcon,
    items: [
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "interaction.connections",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "interaction.connections",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "interaction.connections",
      },
    ],
  },
];

//#endregion

//#region interactionSettings
const exhibitorTemplateSettings = {
  name: "Exhibitors",
  settings: exhibitorSettingsList,
};
const agendaTemplateSettings = {
  name: "Agenda",
  settings: agendaSettingsList,
};
const breakoutsTemplateSettings = {
  name: "Breakouts",
  settings: breakoutSettingsList,
};
const userCardTemplateSettings = {
  name: "UserCard",
  settings: userCardSettingsList,
};
const clientFrameTemplateSettings = {
  name: "ClientFrame",
  settings: clientFrameSettingsList,
};
const chatFrameTemplateSettings = {
  name: "Chat",
  settings: chatSettingsList,
};
const speakerSignTemplateSettings = {
  name: "SpeakerSign",
  settings: [],
};
const clientListTemplateSettings = {
  name: "ClientList",
  settings: clientListSettingsList,
};
const connectionsTemplateSettings = {
  name: "Connections",
  settings: connectionSettingsList,
};
const breakoutRandomizerTemplateSettings = {
  name: "ClientList",
  settings: breakoutSettingsList,
};
const pollTemplateSettings = {
  name: "PollModule",
  settings: pollTemplateSettingsList,
};
//#endregion

//#region templatesettings

const mainTemplateSettingsList = [
  {
    group: "Main",
    icon: <PanoramaOutlinedIcon className="primary-text" />,
    open: true,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        pathSpread: ["main.background", "main.backgroundColor"],
        path: "main",
      },
      {
        name: "backgroundUrl",
        label: "BackgroundImage",
        type: "MULTI_INPUT",
        showIf: null,
        pathSpread: ["main.background", "main.backgroundUrl"],
        path: "main",
      },
    ],
  },
];

const contentTemplateSettingsList = [
  {
    group: "Content",
    icon: frameIcon,
    open: false,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "content",
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "content",
        extra: {
          defaultValue: 1,
          units: ["%", "rem", "px", "vh"],
          max: 50,
          min: 0,
        },
      },
      {
        name: "borderColor",
        label: "BorderCoor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "content",
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "content",
        extra: {
          defaultValue: 1,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0,
        },
      },
    ],
  },
];

const titleTemplateSettingsList = [
  {
    group: "Title",
    icon: titleIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "title",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "letterSpacing",
        label: "LetterSpacing",
        type: "SLIDER",
        showIf: null,
        path: "title",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "title",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "title",
      },
    ],
  },
];

const subtitleTemplateSettingsList = [
  {
    group: "Subtitle",
    icon: subtitleIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TitleColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "subtitle",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "subtitle",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "letterSpacing",
        label: "LetterSpacing",
        type: "SLIDER",
        showIf: null,
        path: "subtitle",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "subtitle",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "subtitle",
      },
    ],
  },
];

const textTemplateSettingsList = [
  {
    group: "Text",
    icon: textIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "text",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "text",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "letterSpacing",
        label: "LetterSpacing",
        type: "SLIDER",
        showIf: null,
        path: "text",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "text",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "text",
      },
    ],
  },
];

const inputTemplateSettingsList = [
  {
    group: "Input",
    icon: inputIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "input",
      },
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "input",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "input",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "input",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "input",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "input",
        extra: {
          defaultValue: 15,
          units: ["px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "input",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "input",
      },
    ],
  },
];

const linkTemplateSettingsList = [
  {
    group: "Link",
    icon: linkIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "input",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "input",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "letterSpacing",
        label: "LetterSpacing",
        type: "SLIDER",
        showIf: null,
        path: "input",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "input",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "input",
        separator: true,
      },
      {
        name: "color",
        label: "HoverTextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "a.&:hover",
      },
      {
        name: "color",
        label: "HoverBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "a.&:hover",
      },
    ],
  },
];

const buttonTemplateSettingsList = [
  {
    group: "Button",
    icon: buttonIcon,
    open: false,
    items: [
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "button",
      },
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "button",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "button",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },

      {
        name: "borderRadius",
        label: "BorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "button",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      /*  {
        name: "padding",
        label: "HorizontalPadding",
        type: "SLIDER",
        showIf: null,
        pathSpread: ["button.paddingLeft", "button.paddingRight"],
        path: "button",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0,
          steps: 0.1,
        },
      },
      {
        name: "padding",
        label: "VerticalPadding",
        type: "SLIDER",
        showIf: null,
        pathSpread: ["paddingTop", ".paddingBottom"],
        path: "button",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0,
          steps: 0.1,
        },
      }, */
      {
        name: "letterSpacing",
        label: "LetterSpacing",
        type: "SLIDER",
        showIf: null,
        path: "button",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          steps: 0.1,
          min: 0,
        },
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "button",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "button",
        separator: true,
      },
      {
        name: "color",
        label: "HoverTextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "button.&:hover",
      },
      {
        name: "backgroundColor",
        label: "HoverBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "button.&:hover",
      },
    ],
  },
];

const scrollTemplateSettingsList = [
  {
    group: "Scroll",
    icon: scrollIcon,
    open: false,
    items: [
      {
        name: "trackBackgroundColor",
        label: "TrackBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "scrollbar",
      },
      {
        name: "thumbBackgroundColor",
        label: "ThumbBackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "scrollbar",
      },
      {
        name: "thumbColorHover",
        label: "ThumbColorHover",
        type: "COLOR_PICKER",
        showIf: null,
        path: "scrollbar",
      },
      {
        name: "thumbBorderRadius",
        label: "ThumbBorderRadius",
        type: "SLIDER",
        showIf: null,
        path: "scrollbar",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "width",
        label: "Width",
        type: "SLIDER",
        showIf: null,
        path: "scrollbar",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 50,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];

const tableHeadTemplateSettingsList = [
  {
    group: "TableHead",
    icon: tableHeadIcon,
    open: false,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "thead",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "thead",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "thead",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "thead",
        separator: true,
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "thead",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "thead",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "thead",
        extra: {
          defaultValue: 15,
          units: ["px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "padding",
        label: "Padding",
        type: "SLIDER",
        showIf: null,
        path: "thead",
        extra: {
          defaultValue: 15,
          units: ["px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];

const tableCellTemplateSettingsList = [
  {
    group: "TableCell",
    icon: tableIcon,
    open: false,
    items: [
      {
        name: "backgroundColor",
        label: "BackgroundColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "tcell",
      },
      {
        name: "color",
        label: "TextColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "tcell",
      },
      {
        name: "borderColor",
        label: "BorderColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "tcell",
      },
      {
        name: "fontFamily",
        label: "FontFamily",
        type: "FONTFAMILY_SELECT",
        showIf: null,
        path: "tcell",
        separator: true,
      },
      {
        name: "fontWeight",
        label: "FontWeight",
        type: "FONTWEIGHT_SELECT",
        showIf: null,
        path: "tcell",
      },
      {
        name: "fontSize",
        label: "FontSize",
        type: "SLIDER",
        showIf: null,
        path: "tcell",
        extra: {
          defaultValue: 15,
          units: ["%", "rem", "px", "vh"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "borderWidth",
        label: "BorderWidth",
        type: "SLIDER",
        showIf: null,
        path: "tcell",
        extra: {
          defaultValue: 15,
          units: ["px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "padding",
        label: "Padding",
        type: "SLIDER",
        showIf: null,
        path: "tcell",
        extra: {
          defaultValue: 15,
          units: ["px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
    ],
  },
];

const chartTemplateSettingsList = [
  {
    group: "Chart",
    icon: chartIcon,
    open: false,
    items: [
      {
        name: "maxWidth",
        label: "PresenterMaxWidth",
        type: "SLIDER",
        showIf: null,
        path: "content",
        extra: {
          defaultValue: 15,
          units: ["%", "px"],
          max: 100,
          min: 0.1,
          min: 0.1,
        },
      },
      {
        name: "color1",
        label: "Color1",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart.colors",
      },
      {
        name: "color2",
        label: "Color2",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart.colors",
      },
      {
        name: "color3",
        label: "Color3",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart.colors",
      },
      {
        name: "color4",
        label: "Color4",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart.colors",
      },
      {
        name: "color5",
        label: "Color5",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart.colors",
      },
      {
        name: "textflowColor",
        label: "TextFlowColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart",
      },
      {
        name: "textflowBgColor",
        label: "TextFlowBgColor",
        type: "COLOR_PICKER",
        showIf: null,
        path: "chart",
      },
    ],
  },
];

//#endregion

const mainTemplateSettings = {
  name: "Main",
  settings: mainTemplateSettingsList,
};

const contentTemplateSettings = {
  name: "Content",
  settings: contentTemplateSettingsList,
};

const titleTemplateSettings = {
  name: "Title",
  settings: titleTemplateSettingsList,
};
const subtitleTemplateSettings = {
  name: "Subtitle",
  settings: subtitleTemplateSettingsList,
};
const textTemplateSettings = {
  name: "Text",
  settings: textTemplateSettingsList,
};
const inputTemplateSettings = {
  name: "Input",
  settings: inputTemplateSettingsList,
};
const linkTemplateSettings = {
  name: "Link",
  settings: linkTemplateSettingsList,
};

const tableHeadTemplateSettings = {
  name: "TableHead",
  settings: tableHeadTemplateSettingsList,
};

const tableCellTemplateSettings = {
  name: "TableCell",
  settings: tableCellTemplateSettingsList,
};

const buttonTemplateSettings = {
  name: "Button",
  settings: buttonTemplateSettingsList,
};
const scrollTemplateSettings = {
  name: "Scroll",
  settings: scrollTemplateSettingsList,
};
const chartTemplateSettings = {
  name: "Chart",
  settings: chartTemplateSettingsList,
};

export const interactionTemplateSettings = [
  { ...connectionsTemplateSettings },
  { ...exhibitorTemplateSettings },
  { ...clientFrameSettingsList },
  { ...chatFrameTemplateSettings },
  { ...agendaTemplateSettings },
  { ...breakoutsTemplateSettings },
  { ...clientListTemplateSettings },
  { ...linkTemplateSettings },
  { ...userCardTemplateSettings },
  { ...pollTemplateSettings },
  { ...tableHeadTemplateSettings },
  { ...tableCellTemplateSettings },
  { ...chartTemplateSettings },
];

export const templateSettings = [
  { ...mainTemplateSettings },
  { ...contentTemplateSettings },
  { ...titleTemplateSettings },
  { ...subtitleTemplateSettings },
  { ...textTemplateSettings },
  { ...inputTemplateSettings },
  { ...linkTemplateSettings },
  { ...buttonTemplateSettings },
  { ...scrollTemplateSettings },
  { ...tableHeadTemplateSettings },
  { ...tableCellTemplateSettings },
  { ...chartTemplateSettings },
];
